import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';

export class HandlingUnit extends CompanyEntity {
  productMasterDataId!: string;
  parentId!: string;
  quantity!: number;
  default: boolean = false;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
